import Swiper from 'swiper';
import { Navigation, A11y, Autoplay, EffectFade } from 'swiper/modules';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

const populateReviews = async () => {
  const reviews_json = JSON.parse(document.querySelector('[data-featured-reviews-json]').textContent);
  let reviews_data = [];
  let reviews_html = '';

  // Make sure we have at least the image and link available. Draft products don't have link
  reviews_json.forEach(review => {
    if (review.product_link !== null && (review.illustration !== null || review.product_image !== null)) {
      reviews_data.push(review);
    }
  });

  // Shuffle the array
  const sliderEl = document.querySelector('[data-featured-reviews-slider]');
  if (sliderEl.dataset.useRandom === "1") {
    // reviews_data = _.shuffle(reviews_data);
    // Fisher-Yates shuffle
    for (let i = reviews_data.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [reviews_data[i], reviews_data[j]] = [reviews_data[j], reviews_data[i]];
    }
  }

  // We just want the first n elements
  reviews_data = reviews_data.slice(0, Number(sliderEl.dataset.totalReviews));

  reviews_data.forEach(review => {
    reviews_html += `
      <div class="featured-reviews__review featured-review-item swiper-slide">
        <div class="featured-review-item__container">
          <div class="featured-review-item__image">
            <img loading="lazy" src="${review.product_image}" width="265" height="385" alt="${review.quote.replace(/"/g, "'")}" />
          </div>

          <div class="featured-review-item__text">
            <h2 class="featured-reviews__title" tabindex="0">${$('[data-featured-reviews-slider]').data('title')}</h2>
            <h3 class="featured-review-item__quote" tabindex="0">${review.quote}</h3>
            <p class="featured-review-item__author" tabindex="0">- ${review.author}</p>
            <a class="featured-review-item__product" href="${review.product_link}" tabindex="0">${review.product_title}</a>
          </div>
        </div>
      </div>
    `;
  });

  document.querySelector('[data-featured-reviews-items]').innerHTML = reviews_html;
};

const initSlider = (sliderSelector) => {
  const slider = document.querySelector(sliderSelector);
  const sliderEl = document.querySelector('[data-featured-reviews-slider]');
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, Autoplay, EffectFade ],
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoHeight: false,
    freeMode: false,
    centeredSlides: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: Number(sliderEl.dataset.slideDelay),
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      769: {
        freeMode: false,
        autoHeight: false,
        centeredSlides: true,
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(document.querySelector('.featured-reviews .swiper'));
      },
    }
  });
};

export default async () => {
  if (!document.querySelector('.featured-reviews .swiper') || !document.querySelector('[data-featured-reviews-json]')) {
    return;
  }

  await populateReviews();

  initSlider('.featured-reviews .swiper');
};
